__turbopack_context__.v({
  "backButton": "modal-components-module__KJHORa__backButton",
  "body": "modal-components-module__KJHORa__body",
  "closeButton": "modal-components-module__KJHORa__closeButton",
  "footer": "modal-components-module__KJHORa__footer",
  "form": "modal-components-module__KJHORa__form",
  "headerWrapper": "modal-components-module__KJHORa__headerWrapper",
  "skipButton": "modal-components-module__KJHORa__skipButton",
  "subtitle": "modal-components-module__KJHORa__subtitle",
  "title": "modal-components-module__KJHORa__title",
});
